import { withScript } from 'metrix-common3';
import styled from 'styled-components';

const SupportButton = styled.div`
    position: fixed;
    cursor: pointer;
    bottom: 40px;
    right: 10px;
`;

const SupportPartner = () => {
    return <SupportButton id='support-box-container' />;
};

const WrappedSupportPartner = withScript(
    SupportPartner,
    'ze-snippet',
    'https://static.zdassets.com/ekr/snippet.js?key=@&zendesk&@',
    '',
);

export default WrappedSupportPartner;
